<div #container (keydown)="handleKeyDown($event)" tabindex="0" class="wrapper">
  <rt-redactor-inserts-dropdown-header
    [hasBackAction]="hasBackAction"
    [hasSearch]="state.questionnairesTemplates.length > 5"
    [searchQuery]="state.searchQuery"
    [searchPlaceholder]="'app.common.placeholders.search.questionnaires.other' | translate"
    [label]="'app.redactor_inserts.questionnaires.dropdown.heading' | translate"
    [hasSettings]="!!state.questionnairesTemplates.length"
    (searchQueryChange)="onSearchQueryChange($event)"
    (goBack)="goBack()"
    (goToSettings)="goToSettings('/settings/questionnaires')"
    (focusChanges)="onFocusChanges($event)"
    (closeDropdown)="closeDropdown.emit()"
  />

  @if (!insideTemplate) {
    @if (state.questionnairesTemplateGroups.length > 0) {
      <div class="group-container">
        @for (
          questionnairesTemplateGroup of state.questionnairesTemplateGroups;
          track groupsTrackByFn($index, questionnairesTemplateGroup);
          let lastGroup = $last
        ) {
          <div>
            <rt-dropdown-header [isSubheading]="true">
              {{ questionnairesTemplateGroup.groupName }}
            </rt-dropdown-header>
            @for (
              template of questionnairesTemplateGroup.groupedQuestionnairesTemplates;
              track templatesTrackByFn($index, template);
              let lastItem = $last
            ) {
              <rt-dropdown-item
                #eleRef
                [highlighted]="isSelected(template, eleRef)"
                [noDivider]="lastGroup && lastItem"
                (click)="questionnairesTemplateChoose(template)"
              >
                {{ template.name }}
              </rt-dropdown-item>
            }
          </div>
        }
      </div>
    }

    @if (state.questionnairesTemplates.length === 0 && !state.searchQuery.length) {
      <rt-empty-state
        [title]="'app.redactor_inserts.questionnaires.dropdown.empty_state_title' | translate"
        [desc]="'app.redactor_inserts.questionnaires.dropdown.empty_state_desc' | translate"
        variant="small"
        class="empty-state"
        padding-lr
      >
        <rt-button variant="primary" (click)="navigateToQuestionnaires()">
          {{ 'app.redactor_inserts.questionnaires.dropdown.empty_state_button' | translate }}
        </rt-button>
      </rt-empty-state>
    }

    @if (state.questionnairesTemplateGroups.length === 0 && state.searchQuery.length) {
      <rt-empty-state
        [title]="'app.redactor_inserts.questionnaires.dropdown.no_filtered_title' | translate"
        [desc]="'app.redactor_inserts.questionnaires.dropdown.no_filtered_desc' | translate"
        variant="small"
        class="empty-state"
        padding-lr
      />
    }
  }

  @if (insideTemplate) {
    <ng-container *ngTemplateOutlet="insideTemplate" />
  }
</div>
